import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ValueAddTwoTypeAdapter } from './dto/value-addition-two.adapter';
import { ValueAdditionTwoType } from './value-addition-two.entity';
import { ValueAddition2TypesController } from './value-addition2-types.controller';
import { ValueAddition2TypesService } from './value-addition2-types.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ValueAdditionTwoType]),
  ],
  controllers: [ValueAddition2TypesController],
  providers: [ValueAddition2TypesService,ValueAddTwoTypeAdapter,ApplicationExceptionHandler,LogsService],
  exports: [ValueAddition2TypesService]
})
export class ValueAddition2TypesModule {}
